import { render, staticRenderFns } from "./contentPosition-editor.vue?vue&type=template&id=46a4471e&scoped=true"
import script from "./contentPosition-editor.vue?vue&type=script&lang=js"
export * from "./contentPosition-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a4471e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46a4471e')) {
      api.createRecord('46a4471e', component.options)
    } else {
      api.reload('46a4471e', component.options)
    }
    module.hot.accept("./contentPosition-editor.vue?vue&type=template&id=46a4471e&scoped=true", function () {
      api.rerender('46a4471e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-divider/contentPosition-editor.vue"
export default component.exports